import { IDownloadAssistenciaArquivoDiversoUseCase } from "../../../presentation/useCases/read/download_assistencia_arquivo_diverso_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DownloadAssistenciaArquivoDiversoUseCase
 */

export class DownloadAssistenciaArquivoDiversoUseCase implements IDownloadAssistenciaArquivoDiversoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async downloadAssistenciaArquivoDiverso(
    idAssistenciaTecnica: number,
    idAssistenciaArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const blob = await this.repository.downloadAssistenciaArquivoDiverso(idAssistenciaTecnica, idAssistenciaArquivo);
    if (!blob) throw new Error('Erro ao baixar arquivo!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
